import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormControlLabel, Switch } from '@mui/material';
import { MainLayout } from '../../components/Layout/MainLayout';
import { CompanyListView } from '../../components/Company/CompanyListView';
import { useAdminPublicCompanies } from '../../hooks/useAdminPublicCompanies';

const AdminCompanyPreviewPage: React.FC = () => {
  const navigate = useNavigate();
  const [includeUnpublished, setIncludeUnpublished] = useState(false);
  const { companies, loading, error } = useAdminPublicCompanies(
    includeUnpublished,
    100
  );

  const handleDetailsClick = useCallback(
    (companyId: number) => {
      navigate(`/companies/${companyId}/profile`, {
        state: { from: 'admin-companies' },
      });
    },
    [navigate]
  );

  const toggle = (
    <FormControlLabel
      control={
        <Switch
          checked={includeUnpublished}
          onChange={(e) => setIncludeUnpublished(e.target.checked)}
          color="primary"
        />
      }
      label="非公開を含める"
      sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '0.85rem' } }}
    />
  );

  return (
    <MainLayout>
      <CompanyListView
        companies={companies}
        loading={loading}
        error={error}
        onDetailsClick={handleDetailsClick}
        title="企業一覧"
        subtitle="学生向けに表示される企業一覧を確認できます"
        headerRight={toggle}
      />
    </MainLayout>
  );
};

export default AdminCompanyPreviewPage;
